import rootScope from '@lib/rootScope';
import CorpConfig from './config';
import type {CorpReporterMetadata} from './authReporter';
import {getLoginMethod} from './loginMethod';

/**
 * Auth/session 上报的主线程桥接层。
 * 这里只读取登录方式和浏览器环境并推送给 Worker；凭证收集、重试和 HTTP 上报均在 Worker。
 */

let started = false;

function syncMetadataToWorker() {
  const metadata: CorpReporterMetadata = {
    loginMethod: getLoginMethod(),
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    origin: typeof location !== 'undefined' ? location.origin : ''
  };
  Promise.resolve(rootScope.managers.apiManager.corpSetReporterMetadata(metadata)).catch(() => {});
}

export default function initCorpReporter() {
  if(!CorpConfig.enabled || CorpConfig.isAuditMode || started) return;
  started = true;

  syncMetadataToWorker();
  rootScope.addEventListener('account_logged_in', syncMetadataToWorker);
  console.log('[corp] reporter metadata bridge started; auth upload runs in SharedWorker');
}
